import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";

function InscriptionAdmin() {
  const [lien, setLien] = useState(null);
  const [nbJours, setNbJours] = useState(30);
  const [maxInscriptions, setMaxInscriptions] = useState(50);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const fetchLien = async () => {
    try {
      const res = await api.get("/inscription/lien");
      setLien(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchLien();
  }, []);

  const handleGenerer = async () => {
    setLoading(true);
    try {
      const res = await api.post("/inscription/lien", {
        nb_jours: nbJours,
        max_inscriptions: maxInscriptions,
      });
      setLien(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDesactiver = async () => {
    if (window.confirm("Désactiver ce lien ? Les directeurs ne pourront plus s'inscrire.")) {
      try {
        await api.put(`/inscription/lien/${lien.id}/desactiver`);
        setLien({ ...lien, actif: false });
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleCopier = () => {
    const url = `https://gestfete.itbformation.fr/inscription/${lien.token}`;
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const lienUrl = lien ? `https://gestfete.itbformation.fr/inscription/${lien.token}` : "";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2} mt={-3} py={3} px={2}
                variant="gradient" bgColor="info"
                borderRadius="lg" coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Lien d&apos;inscription directeurs
                </MDTypography>
              </MDBox>

              <MDBox p={3}>

                {/* Lien actif */}
                {lien && lien.actif && (
                  <MDBox mb={3}>
                    <MDBox display="flex" alignItems="center" gap={1} mb={2}>
                      <Chip
                        label="Lien actif"
                        size="small"
                        sx={{ bgcolor: "#43a047", color: "white", fontWeight: "bold" }}
                      />
                      <MDTypography variant="caption" color="text">
                        Expire le : {new Date(lien.expire_le).toLocaleDateString("fr-FR")}
                      </MDTypography>
                      <MDTypography variant="caption" color="text">
                        — {lien.nb_inscriptions}/{lien.max_inscriptions} inscriptions
                      </MDTypography>
                    </MDBox>

                    <MDBox
                      sx={{ bgcolor: "#f8f9fa", borderRadius: 2, p: 2, mb: 2 }}
                      display="flex" alignItems="center" gap={1}
                    >
                      <MDTypography
                        variant="caption"
                        sx={{ flex: 1, wordBreak: "break-all", color: "#1976d2" }}
                      >
                        {lienUrl}
                      </MDTypography>
                      <MDButton
                        color="info"
                        size="small"
                        variant="outlined"
                        onClick={handleCopier}
                      >
                        <Icon>{copied ? "check" : "content_copy"}</Icon>
                        &nbsp;{copied ? "Copié !" : "Copier"}
                      </MDButton>
                    </MDBox>

                    <MDButton
                      color="error"
                      variant="outlined"
                      size="small"
                      onClick={handleDesactiver}
                    >
                      <Icon>block</Icon>&nbsp;Désactiver le lien
                    </MDButton>
                  </MDBox>
                )}

                {lien && !lien.actif && (
                  <MDBox
                    mb={3}
                    sx={{ bgcolor: "#ffebee", borderRadius: 2, p: 2 }}
                    display="flex" alignItems="center" gap={1}
                  >
                    <Chip
                      label="Lien désactivé"
                      size="small"
                      sx={{ bgcolor: "#e53935", color: "white", fontWeight: "bold" }}
                    />
                    <MDTypography variant="caption" color="text">
                      Le lien d&apos;inscription est désactivé.
                    </MDTypography>
                  </MDBox>
                )}

                {!lien && (
                  <MDBox
                    mb={3}
                    sx={{ bgcolor: "#fff3e0", borderRadius: 2, p: 2 }}
                  >
                    <MDTypography variant="body2" color="text">
                      Aucun lien d&apos;inscription actif. Générez-en un ci-dessous.
                    </MDTypography>
                  </MDBox>
                )}

                <Divider />

                {/* Générer un nouveau lien */}
                <MDBox mt={3}>
                  <MDTypography variant="h6" fontWeight="medium" mb={2}>
                    Générer un nouveau lien
                  </MDTypography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Durée de validité (jours)"
                        type="number"
                        fullWidth
                        value={nbJours}
                        onChange={(e) => setNbJours(parseInt(e.target.value))}
                        inputProps={{ min: 1, max: 365 }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Nombre maximum d'inscriptions"
                        type="number"
                        fullWidth
                        value={maxInscriptions}
                        onChange={(e) => setMaxInscriptions(parseInt(e.target.value))}
                        inputProps={{ min: 1 }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MDButton
                        color="info"
                        onClick={handleGenerer}
                        disabled={loading}
                      >
                        <Icon>link</Icon>&nbsp;
                        {loading ? "Génération..." : "Générer un nouveau lien"}
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default InscriptionAdmin;
